import { Background, Circle, Input, StyledLabel } from './Toggle.styles';

import { FC } from 'react';
import { ToggleProps } from './types';

const Toggle: FC<ToggleProps> = ({
	disabled,
	handleChange,
	handleClick,
	id,
	isChecked,
	name,
	isPunchup,
	...rest
}: ToggleProps) => (
	<StyledLabel htmlFor={id ?? name} disabled={disabled}>
		<Input
			{...rest}
			aria-label={id ?? name}
			id={id ?? name}
			name={name}
			type="checkbox"
			onChange={handleChange}
			isChecked={isChecked}
			disabled={disabled}
			onClick={handleClick}
			readOnly
			checked={isChecked}
			isPunchup={isPunchup}
		/>
		<Background disabled={disabled} isChecked={isChecked}>
			<Circle disabled={disabled} />
		</Background>
	</StyledLabel>
);

export { Toggle };
